import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { Box, Grid } from "@material-ui/core";
import moment from "moment";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLayoutEffect } from "react";

/** Import entities */
import { CxQuestion } from "../../entity/entities";

/** Import constants */
import { MAX_DATE, MIN_DATE, DEFAULT_FORMATED_DATE } from "../../constant/Enum";

/** Import reducer */
import { changeCalendar } from "./inputAnswerSlice";

/** Import hooks */
import { useAppDispatch, useAppSelector } from "../../app/hooks";

/** Import components */
import { QuestionText } from "./QuestionText";

/** Import util */
import LocalizedUtil, { getLocaleForCalendar } from "../../util/LocalizedUtil";
import DATA_QA from "../../util/DataQaAttr";

export function Calendar(props: {
  pageIndex: number;
  questionIndex: number;
  cxQuestion: CxQuestion;
  control: Control<any>;
}) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { control, pageIndex, questionIndex, cxQuestion } = props;

  useLayoutEffect(() => {
    moment.locale(getLocaleForCalendar())
  }, [])

  const answerStr = useAppSelector((state) => {
    const cxQuestionPage = state.inputAnswer.answer.cxAnswerPageDtos[pageIndex];
    const cxQuestion = cxQuestionPage.cxAnswers[questionIndex];

    return cxQuestion.answerStr
      ? moment(cxQuestion.answerStr, DEFAULT_FORMATED_DATE, true)
        .format(DEFAULT_FORMATED_DATE)
      : null;
  });

  const handleChange = (date: string | null | undefined) => {
    dispatch(
      changeCalendar({
        pageIndex,
        questionIndex,
        str: date ? moment(date, DEFAULT_FORMATED_DATE, true)
          .format(DEFAULT_FORMATED_DATE) : "",
      })
    );
  };

  return (
    <>
      <QuestionText cxQuestion={cxQuestion} />
      <Box mx={4}>
        <Grid container>
          <Grid item xs={12}>
            <MuiPickersUtilsProvider
              libInstance={moment}
              utils={LocalizedUtil}
              locale={getLocaleForCalendar()}
            >
              <Controller
                control={control}
                name={`calendar-${pageIndex}-${questionIndex}`}
                render={({ field: { onChange, onBlur, ref, ...rest } }) => (
                  <KeyboardDatePicker
                    {...rest}
                    emptyLabel="yyyy/mm/dd"
                    invalidLabel=""
                    invalidDateMessage={t("question.calender.incorrect_date_format")}
                    minDateMessage={t("question.calender.cannot_set_date_before_min_year", { minYear: 1900 })}
                    maxDateMessage=""
                    animateYearScrolling
                    autoOk
                    okLabel={<></>}
                    cancelLabel={<></>}
                    showTodayButton
                    todayLabel={<>{t('question.calender.today')}</>}
                    clearable
                    clearLabel={<>{t('question.btn.delete')}</>}
                    margin="normal"
                    format={DEFAULT_FORMATED_DATE}
                    value={answerStr}
                    maxDate={MAX_DATE}
                    onChange={(event, date) => {
                      handleChange(date);
                      onChange(event, date);
                      onBlur();
                    }}
                    id={`${DATA_QA.INPUT.CALENDER}-${
                      pageIndex + 1
                    }-${questionIndex}`}
                  />
                )}
                rules={{
                  validate: {
                    validFormat: (v) => {
                      const isValidDate = moment(v, DEFAULT_FORMATED_DATE, true).isValid();
                      return !v || isValidDate;
                    },
                    validMin: (v) =>
                      !v || moment(v, DEFAULT_FORMATED_DATE, true).isSameOrAfter(moment(MIN_DATE)),
                  },
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
